export type JsonApiError = {
  result?: {
    errors?: {
      code: string;
      detail: string[] | string;
      field?: string | null;
    }[];
  };
};

export class CardValidationError extends Error {
  displayMessage: string;
  networkError?: JsonApiError;

  constructor(message: string) {
    super(message);
    this.displayMessage =
      'There was a problem processing your credit card, please double check your data and try again.';
  }
}
